import React, { createContext, useState } from 'react';

const LanguageContext = createContext({
  language: 'English',
  setLanguage: () => {}
});

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState('English');

  return (
    <LanguageContext.Provider value={{ language, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
}

export default LanguageContext;
